function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v15H0V7.5Z",
    style: {
      fill: "#009739"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,11.786h30v6.429H0v-6.429Z",
    style: {
      fill: "#ffd100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,15L0,22.5V7.5l7.5,7.5Z",
    style: {
      fill: "#ef3340"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M15,12.679l1.509,4.643-3.949-2.869h4.882l-3.949,2.869,1.507-4.643Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a1",
    "data-name": "a",
    d: "M22.5,12.679l1.509,4.643-3.949-2.869h4.882l-3.949,2.869,1.507-4.643Z",
    style: {
      fill: "#000000"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSt);
export default __webpack_public_path__ + "static/media/ST.ebea72d9fefc0d074e6e30f78ac0d956.svg";
export { ForwardRef as ReactComponent };